import React, { useState } from "react";
import data from "../data";
import { Link } from "react-router-dom";

const Print = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [allImages, setAllImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openViewer = (images, index) => {
    setAllImages(images);
    setSelectedImage(images[index].src);
    setCurrentIndex(index);
  };

  const closeViewer = () => {
    setSelectedImage(null);
    setAllImages([]);
    setCurrentIndex(0);
  };

  const nextImage = () => {
    const newIndex = (currentIndex + 1) % allImages.length;
    setSelectedImage(allImages[newIndex].src);
    setCurrentIndex(newIndex);
  };

  const prevImage = () => {
    const newIndex = (currentIndex - 1 + allImages.length) % allImages.length;
    setSelectedImage(allImages[newIndex].src);
    setCurrentIndex(newIndex);
  };

  return (
    <div className="mt-10 container mx-auto px-6 py-6 sm:px-8 md:px-12 lg:px-16 xl:px-60">
      {/* Pricing Section */}
      <div className="bg-gray-100 p-8 rounded-lg shadow-lg mb-12">
        <h1 className="text-4xl font-bold text-primary text-center">
          {data.print.title}
        </h1>
        <p className="text-lg text-gray-700 mt-4 text-center max-w-2xl mx-auto">
          {data.print.description}
        </p>

        {/* Print Services */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-8">
          {data.print.services.map((service, index) => (
            <div
              key={index}
              className="p-6 border rounded-lg shadow-lg text-left bg-white"
            >
              <h3 className="text-2xl font-semibold text-primary">
                {service.title}
              </h3>
              <p className="text-xl text-secondary font-bold">
                {service.price}
              </p>
              <p className="text-gray-600 mt-2">{service.description}</p>
              <ul className="mt-4 text-gray-700 list-disc pl-6">
                {service.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Request A Print Button */}
        <div className="mt-8 text-center">
          <Link
            to="/contact?type=Print%20Job"
            className="bg-primary text-white px-8 py-4 text-xl rounded-lg shadow-md transition-transform duration-300 ease-in-out  hover:font-bold"
          >
            Request A Print
          </Link>
        </div>
      </div>

      {/* Inspiration Section */}
      <div className="bg-gray-50 p-8 rounded-lg shadow-lg mb-12">
        <h2 className="text-3xl font-bold text-primary text-center">
          Looking for Inspiration?
        </h2>
        <p className="text-lg text-gray-700 mt-4 text-center max-w-2xl mx-auto">
          Check out all the surfaces we can print on for you below.
        </p>
      </div>

      {/* Print Portfolio Section */}
      <div className="bg-white p-8 rounded-lg shadow-lg">
        <div className="flex flex-col gap-12">
          {data.print.categories.map((category, index) => (
            <div key={index} className="w-full">
              <h3 className="text-3xl font-semibold text-primary">
                {category.title}
              </h3>
              <p className="text-gray-700 mt-2">{category.description}</p>

              {/* Row-Based Layout for Gallery */}
              <div className="mt-6 space-y-6">
                {category.images
                  .reduce((rows, image, idx) => {
                    if (idx % 3 === 0) rows.push([]); // Create a new row every 3 images
                    rows[rows.length - 1].push({ ...image, actualIndex: idx }); // Store actual index
                    return rows;
                  }, [])
                  .map((row, rowIndex) => (
                    <div key={rowIndex} className="flex justify-center gap-6">
                      {row.map((image) => (
                        <div
                          key={image.actualIndex}
                          className="relative cursor-pointer hover:brightness-75"
                          onClick={() =>
                            openViewer(category.images, image.actualIndex)
                          }
                        >
                          <img
                            src={image.src}
                            alt={image.alt}
                            className="rounded-lg shadow-lg object-cover"
                            style={{
                              width: "366px",
                              height:
                                image.size === "large"
                                  ? "253px"
                                  : image.size === "medium"
                                  ? "205px"
                                  : "203px",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Viewer (Full-Screen Modal) */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-6">
          <button
            onClick={closeViewer}
            className="absolute top-6 right-6 text-white text-4xl font-bold"
          >
            ✕
          </button>
          <button
            onClick={prevImage}
            className="absolute left-6 text-white text-5xl font-bold"
          >
            ◀
          </button>
          <img
            src={selectedImage}
            alt="Enlarged view"
            className="w-[90vw] h-[90vh] object-contain rounded-lg shadow-lg"
          />
          <button
            onClick={nextImage}
            className="absolute right-6 text-white text-5xl font-bold"
          >
            ▶
          </button>
        </div>
      )}

      {/* Video Section */}
      <div className="bg-gray-100 p-8 rounded-lg shadow-lg mt-16 flex flex-col items-center text-center">
        <h2 className="text-4xl font-bold text-primary">
          {data.print.whatElse.title}
        </h2>
        <p className="text-lg text-gray-700 mt-4 max-w-2xl">
          {data.print.whatElse.description}
        </p>
        <div className="mt-6 w-full flex justify-center">
          <div className="w-full max-w-4xl h-auto">
            <iframe
              className="w-full h-[500px] rounded-lg shadow-lg"
              src={data.print.whatElse.video}
              title="What Else Can We Print On"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Print;
